import { render, staticRenderFns } from "./ProjectsModal.vue?vue&type=template&id=1e9896b3&scoped=true"
import script from "./ProjectsModal.vue?vue&type=script&lang=ts"
export * from "./ProjectsModal.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsModal.vue?vue&type=style&index=0&id=1e9896b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9896b3",
  null
  
)

export default component.exports